class Customer.Signature extends Backbone.Model

  forType: (type) ->
    type in @typeNames()

  forLabels: (labels) ->
    _.isEmpty(@labels()) || !_.isEmpty(_.intersection(@labelNames(), labels))

  typeNames: ->
    _.map(@types(), (type) -> type.name)

  labelNames: ->
    _.map(@labels(), (label) -> label.name)

  types: ->
    @get('types')

  labels: ->
    @get('labels')

  appendToResponse: ->
    @get('append_to_response')



class Customer.SignaturesCollection extends Backbone.Collection
  model: Customer.Signature

  signaturesFor: (subType, labels, callback) ->
    result = @filter((signature) ->
      signature.forType(subType) && signature.forLabels(labels)
    )
    signature = @_getText(result)
    callback(signature)

  signaturesForInitialResponse: (subType, labels, callback) ->
    result = @filter((signature) ->
      signature.forType(subType) && signature.forLabels(labels) && signature.appendToResponse()
    )
    signature = @_getText(result)
    callback(signature)

  _getText: (result) ->
    if result != [] && result[0]?
      if result[0].get('text_html')?
        signature = result[0].get('text_html')
      else
        signature = result[0].get('text')
    else
      signature = ''

  signaturesForNewTicket: (subType, callback) ->
    result = @filter((signature) ->
      signature.forType(subType)
    )
    callback(result)
